/**
 * Enum for team member field names that can change.
 */
export enum TeamMemberChangedFieldName {
  STATUS = 'STATUS',
  DEPARTMENT = 'DEPARTMENT',
  ROLE = 'ROLE',
  SENIORITY = 'SENIORITY',
  LOCATION = 'LOCATION',
  MANAGER = 'MANAGER',
  IS_MANAGER = 'IS_MANAGER',
  CAPACITY = 'CAPACITY',
  ON_DEMAND = 'ON_DEMAND',
  INTERNAL_RATE = 'INTERNAL_RATE',
  EXTERNAL_RATE = 'EXTERNAL_RATE',
  IS_HOURLY_RATED = 'IS_HOURLY_RATED',
  CURRENCY = 'CURRENCY',
  TOTAL_WORKING_MINUTES = 'TOTAL_WORKING_MINUTES',
  MEMBERSHIP_TYPE = 'MEMBERSHIP_TYPE',
}

/**
 * API response type for team member changed field.
 * Represents a field that changed in a team member's state, with recursive support for nested changes.
 */
export interface TeamMemberChangedFieldResponse {
  fieldName: TeamMemberChangedFieldName;
  fieldLocalizedName?: object;
  oldValue?: object | null;
  oldValueKey?: number | null;
  newValue?: object | null;
  newValueKey?: number | null;
  /** Recursive structure for nested field changes */
  subfieldChanges?: TeamMemberChangedFieldResponse[] | null;
}
